module.exports = __webpack_public_path__ + "static/media/logout.6b02703b.svg";